import { render, staticRenderFns } from "./SingleClient.vue?vue&type=template&id=2d17a84f&scoped=true&"
import script from "./SingleClient.vue?vue&type=script&lang=js&"
export * from "./SingleClient.vue?vue&type=script&lang=js&"
import style0 from "./SingleClient.vue?vue&type=style&index=0&id=2d17a84f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17a84f",
  null
  
)

export default component.exports